import { getDataMapper, mapArray, mapField } from "@/shared";

// Маппер для отдельного объекта языка (из сервера)
export const mapLanguageFromServer = getDataMapper({
    id: mapField("id", Number),
    code: mapField("code"),
    title: mapField("title"),
    visible: mapField("visible"),
    createdAt: mapField("created_at"),
    updatedAt: mapField("updated_at"),
});

// Маппер для массива объектов языков
export const mapLanguagesFromServer = mapArray(mapLanguageFromServer);
